import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  ModalAvailable,
  ActionsForAll,
  AnnouncementCard,
  republishAnnouncement,
  setAnnouncementState,
  setAnnouncementPage,
  putAnnouncementInactive,
  fetchAnnouncementDetail,
  clearAnnouncementDeleteData,
  clearAnnouncementRepublishData,
  deleteAnnouncement,
  selectAnnouncement,
  clearAnnouncementSelecteds,
  ModalAvailableDetail,
  ModalConfirm,
  clearAnnouncementPutInactiveData,
  fetchAnnouncement,
  AnnouncementModel
} from '@app/src/views/MyAccount/listAvailable';
import {
  Head,
  TitleWrapper,
  Content,
  Subtitle,
  ListCurrentAnnouncement,
  ItemCurrent,
  Helper,
  LoaderWrapper,
  NotContent,
  FilterWrapper,
  FilterItem,
  Separator,
  Wrapper,
  FilterList,
  Container,
  TitleAvailable
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { ModalAvailableRepublish } from '../ModalAvailable';
import { clearPackageConsumeData, fetchPackageConsume } from '@app/src/views/Package/listPackage';
import { clearAdsRepublishData } from '@app/src/views/StepOne/form';
import { PaginatorFeature } from '@app/src/common/paginator';

const CANT_PAGE_ACTIONS = 10;
const AD_ACTIVE = 1;
const AD_INACTIVE = 2;

export const ListAvailable: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userStorage = JSON.parse(localStorage.getItem('user'));

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [isOpenModalRepublish, setIsOpenModalRepublish] = useState(false);
  const [categoryId, setCategoryId] = useState(0);
  const [itemClicked, setItemClicked] = useState(null);

  const announcements = useSelector(state => state.announcement.data.ads);
  const selecteds = useSelector(state => state.announcement.selecteds);
  const isLoading = useSelector(state => state.announcement.isFetching);
  const isLoadingDelete = useSelector(state => state.announcement.isFetchingDelete);
  const isLoadingPutInactive = useSelector(state => state.announcement.isFetchingPutInactive);
  const responseDelete = useSelector(state => state.announcement.dataDelete);
  const responsePutInactive = useSelector(state => state.announcement.dataPutInactive);
  const packagesConsume = useSelector(state => state.package.dataConsume.packages);
  const urlForConsume = useSelector(state => state.announcement.dataRepublish.url);
  const dataRepublish = useSelector(state => state.announcement.dataRepublish);
  const isLoadingRepublish = useSelector(state => state.announcement.isFetchingRepublish);
  const page = useSelector(state => state.announcement.currentPage);
  const ads = useSelector(state => state.announcement.data.ads);
  const paginator = useSelector(state => state.announcement.data.paginator);
  const currentPage = paginator && paginator.currentPage;
  const totalPages = paginator && paginator.totalPages;
  const state = useSelector(state => state.announcement.currentState);

  useEffect(() => {
    if (packagesConsume && packagesConsume.length === 0) {
      dispatch(fetchPackageConsume(userStorage && userStorage.data && userStorage.data.id));
    }
  }, [packagesConsume]);

  useEffect(() => {
    dispatch(fetchAnnouncement(userStorage && userStorage.data && userStorage.data.id, page, state));
    return () => {
      dispatch(clearPackageConsumeData());
    }
  }, []);

  useEffect(() => {
    if (responseDelete && Object.keys(responseDelete).length > 0) {
      setIsOpenConfirm(false);
      dispatch(fetchAnnouncement(userStorage && userStorage.data && userStorage.data.id, currentPage, state));
      dispatch(clearAnnouncementDeleteData());
    }
  }, [responseDelete]);

  useEffect(() => {
    if (responsePutInactive && Object.keys(responsePutInactive).length > 0) {
      setIsOpenConfirm(false);
      dispatch(fetchAnnouncement(userStorage && userStorage.data && userStorage.data.id, currentPage, state));
      dispatch(clearAnnouncementPutInactiveData());
    }
  }, [responsePutInactive]);

  const getTotalPackageByCategory = (categoryId: number) => {
    return (packagesConsume && packagesConsume.length > 0) ? packagesConsume.filter(item => item.categoryId === categoryId).length : 0;
  };

  const handleClickCardAction = (e, item) => {
    e.preventDefault();
    const element = e.target;
    const action = element.dataset.action;
    const { uniqueId, categoryId } = item;
    setCategoryId(categoryId);
    setItemClicked(item);
    dispatch(clearAdsRepublishData());
    if (action === 'detail') {
      setIsOpenModal(true);
      dispatch(fetchAnnouncementDetail(categoryId, uniqueId));
    }
    if (action === 'republish-print') {
      const totalPackageByCategory = getTotalPackageByCategory(categoryId);
      if (totalPackageByCategory > 1) {
        history.push(`/mi-cuenta/listado-paquetes/${item.categoryId}/${item.uniqueId}`)
      } else if (totalPackageByCategory === 1) {
        dispatch(republishAnnouncement(userStorage && userStorage.data && userStorage.data.id, categoryId, uniqueId));
      } else {
        setIsOpenModalRepublish(true);
      }
    }
    if (action === 'delete') {
      setIsOpenConfirm(true);
    }
  };

  useEffect(() => {
    if (dataRepublish && Object.keys(dataRepublish).length > 0) {
      history.push(urlForConsume);
      dispatch(clearAnnouncementRepublishData());
    }
  }, [dataRepublish]);

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  const handleCloseConfirm = () => {
    setIsOpenConfirm(false);
  };

  const handleCloseModalRepublish = () => {
    setIsOpenModalRepublish(false);
  };

  const handleCheckbox = (checked, item) => {
    dispatch(selectAnnouncement(item.uniqueId, checked));
  };

  const handleClickDelete = () => {
    setIsOpenConfirm(true);
  };

  const getSelectedsChecked = () => {
    const current = selecteds.filter(item => item.checked === true);
    if (current && current.length > 0) {
      return current
    }
    return null;
  };

  const handleClickConfirm = () => {
    const checkeds = getSelectedsChecked();
    if (state === AD_INACTIVE) {
      if (checkeds) {
        dispatch(deleteAnnouncement(checkeds));
      } else {
        dispatch(deleteAnnouncement([itemClicked]));
      }
    }

    if (state === AD_ACTIVE) {
      if (checkeds) {
        dispatch(putAnnouncementInactive(checkeds));
      } else {
        dispatch(putAnnouncementInactive([itemClicked]));
      }
    }
  };

  const handleClickCleanInputs = () => {
    dispatch(clearAnnouncementSelecteds());
    setIsOpenConfirm(false);
  };

  const handleClickItem = (e) => {
    e.preventDefault();
    const element = e.currentTarget;
    const currentActive = Number(element.dataset.active);
    dispatch(setAnnouncementState(currentActive));
    dispatch(setAnnouncementPage(1));
    dispatch(fetchAnnouncement(userStorage && userStorage.data && userStorage.data.id, 1, currentActive));
  };


  const handleClickPaginator = (page: number) => {
    if (page) {
      dispatch(setAnnouncementPage(page));
      dispatch(fetchAnnouncement(userStorage && userStorage.data && userStorage.data.id, page, state));
    }
  };

  return (
    <React.Fragment>
      <Head id="headMyAccount">
        <Container>
          <TitleAvailable>
            <TitleWrapper>Mi cuenta</TitleWrapper>
            {packagesConsume && <ModalAvailable />}
          </TitleAvailable>
          {
            getSelectedsChecked() &&
            <ActionsForAll
              actionText={state === AD_ACTIVE ? 'Dar de baja' : 'Borrar'}
              handleClickDelete={handleClickDelete}
              handleClickCancel={handleClickCleanInputs} />
          }
        </Container>
      </Head>
      <Container>
        <Content>
          <Wrapper>
            <Subtitle>Mis avisos</Subtitle>
            <Separator />
            <FilterWrapper>
              <span>Filtrar:</span>
              <FilterList>
                <FilterItem active={state === AD_ACTIVE} onClick={handleClickItem} data-active={AD_ACTIVE}>
                  <a href="#activos">Activos</a></FilterItem>
                <FilterItem active={state === AD_INACTIVE} onClick={handleClickItem} data-active={AD_INACTIVE}
                ><a href="#inactivos">Inactivos</a></FilterItem>
              </FilterList>
            </FilterWrapper>
          </Wrapper>
          {
            (isLoading) ?
              <LoaderWrapper>
                <Icon data-name='icon-circle' fill='#ccc' width={'16'} height={'16'} />
              </LoaderWrapper>
              :
              (announcements && announcements.length > 0) ?
                <ListCurrentAnnouncement>
                  <Helper>
                    {
                      announcements.map((item: AnnouncementModel, index) => {
                        const currentSelecteds = selecteds.filter(selected => selected.uniqueId === item.uniqueId)[0];
                        const indexSelected = announcements.findIndex(x => x.uniqueId === (itemClicked && itemClicked.uniqueId));
                        return (
                          <ItemCurrent key={index}>
                            <AnnouncementCard
                              colorCategory={CATEGORIES[CATEGORY[item.categoryId]].color}
                              categoryName={item.categoryName}
                              highText={item.title}
                              publicationDate={item.publicationDate}
                              operationType={item.operationType}
                              description={item.description}
                              handleClickAction={(e) => handleClickCardAction(e, item)}
                              inputName={`announcement-${index + 1}`}
                              inputValue={currentSelecteds && currentSelecteds.uniqueId}
                              isChecked={currentSelecteds && currentSelecteds.checked}
                              handleChangeCheckbox={e => handleCheckbox(e, item)}
                              isLoadingRepublish={index === indexSelected && isLoadingRepublish}
                              type={item.type}
                              state={state}
                            />
                          </ItemCurrent>
                        )
                      })
                    }
                  </Helper>
                </ListCurrentAnnouncement>
                :
                <NotContent>{state === AD_ACTIVE ? 'Ud. aún no ha creado avisos.' : 'No se ha encontrado avisos inactivos.'}</NotContent>
          }
        </Content>
        <PaginatorFeature
          initialPage={currentPage}
          totalPages={totalPages}
          pageGroup={CANT_PAGE_ACTIONS}
          handleClickPageActive={handleClickPaginator}
          dataList={ads}
        />
      </Container>
      <ModalAvailableDetail isDisplay={isOpenModal} handleCloseModal={handleCloseModal} />
      <ModalConfirm
        isDisplay={isOpenConfirm}
        handleCloseModal={handleCloseConfirm}
        handleClickCancel={handleCloseConfirm}
        handleClickConfirm={handleClickConfirm}
        isLoadingButtonConfirm={isLoadingDelete || isLoadingPutInactive}
        isDisabledButtonConfirm={isLoadingDelete || isLoadingPutInactive}
        state={state}
      />
      <ModalAvailableRepublish
        isDisplay={isOpenModalRepublish}
        handleCloseModal={handleCloseModalRepublish}
        categoryId={categoryId}
      />
    </React.Fragment>
  )
};